/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import { FormControl, Button, IconButton, Box } from '@mui/material';
import { FilterList } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import { IAutocompleteOption } from '../../../../models/iautocompleteOption';
import { RootState } from '../../../../store/types';
import { ISite } from '../../../../models/isite';

type Props = {
  closeModal: CallableFunction,
}

interface IAutocompleteSite extends ISite {
	value: string,
	label: string,
}

const ScheduledServicesCalendarsFiltersModal: React.FC<Props> = (props) => {
	const dispatch = useDispatch();

	const page = 1;
	const limit = 30;
	const orderBy = "name";
	const order = "asc";

	const [searchTextEquipmentModels, setSearchTextEquipmentModels] = useState('');
	const [equipmentModelsFormated, setEquipmentModelsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedEquipmentModels, setSelectedEquipmentModels] = useState<IAutocompleteOption[]>([]);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedSites, setSelectedSites] = useState<IAutocompleteSite[]>([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedPlaces, setSelectedPlaces] = useState<IAutocompleteOption[]>([]);

	const [searchTextGroup, setSearchTextGroup] = useState('');
	const [groupsFormated, setGroupsFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedGroups, setSelectedGroups] = useState<IAutocompleteOption[]>([]);

  const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedAreas, setSelectedAreas] = useState<IAutocompleteOption[]>([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedCompanies, setSelectedCompanies] = useState<IAutocompleteOption[]>([]);

  const [searchTextFrequencies, setSearchTextFrequencies] = useState('');
	const [frequenciesFormated, setFrequenciesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedFrequencies, setSelectedFrequencies] = useState<IAutocompleteOption[]>([]);
  
  const [searchTextServiceTypes, setSearchTextServiceTypes] = useState('');
	const [serviceTypesFormated, setServiceTypesFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedServiceTypes, setSelectedServiceTypes] = useState<IAutocompleteOption[]>([]);

  const [searchTextUsers, setSearchTextUsers] = useState('')
  const [usersFormated, setUsersFormated] = useState<IAutocompleteOption[]>([]);
	const [selectedUsers, setSelectedUsers] = useState<IAutocompleteOption[]>([]);

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchUsers = useCallback(
    () => dispatch(actions.scheduledServicesFetchValidUsers(page, limit, searchTextUsers, order, orderBy)),
    [page, limit, searchTextUsers, order, orderBy]
  );

	const fetchPlaces = useCallback(
		() => dispatch(actions.scheduledServicesFetchPlacesCalendar(selectedSites)),
		[selectedSites]
	);

	const fetchEquipmentModels = useCallback(
		() => dispatch(actions.scheduledServicesFetchEquipmentModels(page, limit, searchTextEquipmentModels, order, orderBy)),
		[page, limit, searchTextEquipmentModels, order, orderBy]
	);

	const fetchGroups = useCallback(
		() => dispatch(actions.scheduledServicesFetchGroups(page, limit, searchTextGroup, order, orderBy)),
		[page, limit, searchTextGroup, order, orderBy]
	);

  const fetchAreas = useCallback(
		() => dispatch(actions.scheduledServicesFetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.scheduledServicesFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

  const fetchServiceTypes = useCallback(
		() => dispatch(actions.scheduledServicesFetchServiceTypes(page, limit, searchTextServiceTypes, order, orderBy)),
		[page, limit, searchTextServiceTypes, order, orderBy]
	);

	const fetchFrequencies = useCallback(
		() => dispatch(actions.scheduledServicesFetchFrequencies(page, limit, searchTextFrequencies, order, orderBy)),
		[page, limit, searchTextFrequencies, order, orderBy]
	);

  const role = useSelector((state: any) => state.auth.selectedAccess.role);
  const sites = useSelector((state: any) => state.sites.sites);
	const filteredSites = useSelector((state: any) => state.sites.selectedSitesPlaces);
	const loadingSites = useSelector((state: any) => state.sites.loading);

	const places = useSelector((state: RootState) => state.scheduledServices.placesForCalendar);
	const equipmentsModels = useSelector((state: RootState) => state.scheduledServices.equipmentModels);
	const groups = useSelector((state: RootState) => state.scheduledServices.equipmentGroups);
	const areas = useSelector((state: RootState) => state.scheduledServices.areas);
	const companies = useSelector((state: RootState) => state.scheduledServices.companies);
  const frequencies = useSelector((state: RootState) => state.scheduledServices.frequencies);
  const serviceTypes = useSelector((state: RootState) => state.scheduledServices.serviceTypes);
	const users = useSelector((state: RootState) => state.scheduledServices.usersForFilters);

	const filteredPlaces = useSelector((state: RootState) => state.scheduledServices.calendar.filters.places);
	const filteredEquipmentsModels = useSelector((state: RootState) => state.scheduledServices.calendar.filters.equipmentModels);
	const filteredGroups = useSelector((state: RootState) => state.scheduledServices.calendar.filters.equipmentGroups);
	const filteredAreas = useSelector((state: RootState) => state.scheduledServices.calendar.filters.areas);
	const filteredCompanies = useSelector((state: RootState) => state.scheduledServices.calendar.filters.companies);
  const filteredFrequencies = useSelector((state: RootState) => state.scheduledServices.calendar.filters.frequencies);
  const filteredServiceTypes = useSelector((state: RootState) => state.scheduledServices.calendar.filters.serviceTypes);
	const filteredUsers = useSelector((state: RootState) => state.scheduledServices.calendar.filters.users);

	const loadingEquipmentModels = useSelector((state: RootState) => state.scheduledServices.loadingEquipmentModels);
	const loadingPlaces = useSelector((state: RootState) => state.scheduledServices.loadingPlaces);
	const loadingGroups = useSelector((state: RootState) => state.scheduledServices.loadingEquipmentGroups);
	const loadingAreas = useSelector((state: RootState) => state.scheduledServices.loadingAreas);
	const loadingCompanies = useSelector((state: RootState) => state.scheduledServices.loadingCompanies);
  const loadingFrequencies = useSelector((state: RootState) => state.scheduledServices.loadingFrequencies);
  const loadingServiceTypes = useSelector((state: RootState) => state.scheduledServices.loadingServiceTypes);
	const loadingUsersForFilters = useSelector((state: any) => state.scheduledServices.loadingUsersForFilters);

	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeEquipments(filteredEquipmentsModels);
		handleInputChangeGroups(filteredGroups);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
    handleInputChangeFrequencies(filteredFrequencies);
    handleInputChangeServiceTypes(filteredServiceTypes);
		handleInputChangeUsers(filteredUsers);
	}, []);

	useEffect(() => {
		fetchSites();
	}, [searchTextSite]);

	useEffect(() => {
		fetchUsers();
	}, [searchTextUsers]);

	useEffect(() => {
		fetchPlaces();
	}, [selectedSites]);

	useEffect(() => {
		fetchEquipmentModels();
	}, [searchTextEquipmentModels]);

	useEffect(() => {
		fetchGroups();
	}, [searchTextGroup]);

  useEffect(() => {
		fetchAreas();
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies();
    }
	}, [searchTextCompanies]);

  useEffect(() => {
		fetchFrequencies();
	}, [searchTextFrequencies]);

  useEffect(() => {
		fetchServiceTypes();
	}, [searchTextServiceTypes]);

	useEffect(() => {
		setSitesFormated(
			sites.rows.map((site:ISite) => ({ value: site._id, label: site.name, ...site }))
		)
	}, [sites])

	useEffect(() => {
		setUsersFormated(
			users.map((user) => ({ value: user._id, label: user.name }))
		)
	}, [users])

	useEffect(() => {
		setPlacesFormated(
			places.map((place) => ({ value: place._id, label: place.path }))
		)
	}, [places])

	useEffect(() => {
		setEquipmentModelsFormated(
			equipmentsModels.map((equipmentModel) => ({ value: equipmentModel._id, label: equipmentModel.name }))
		)
	}, [equipmentsModels])

	useEffect(() => {
		setGroupsFormated(
			groups.map((group) => ({ value: group._id, label: group.name }))
		)
	}, [groups])

  useEffect(() => {
		setAreasFormated(
			areas.map((area) => ({ value: area._id, label: area.name }))
		)
	}, [areas])

	useEffect(() => {
		setCompaniesFormated(
			companies.map((company) => ({ value: company._id, label: company.name }))
		)
	}, [companies])

  useEffect(() => {
		setFrequenciesFormated(
			frequencies.map((frequency) => ({ value: frequency._id, label: frequency.name }))
		)
	}, [frequencies])

  useEffect(() => {
		setServiceTypesFormated(
			serviceTypes.map((serviceType) => ({ value: serviceType._id, label: serviceType.name }))
		)
	}, [serviceTypes]);

	const handleInputChangeSelectorSites = (text: string) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorUsers = (text: string) => {
    setSearchTextUsers(text);
  }

	const handleInputChangeSelectorPlaces = (text: string) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorEquipments = (text: string) => {
		setSearchTextEquipmentModels(text);
	}

	const handleInputChangeSelectorGroups = (text: string) => {
		setSearchTextGroup(text);
	}

	const handleInputChangeSelectorAreas = (text: string) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text: string) => {
		setSearchTextCompanies(text);
	}

  const handleInputChangeSelectorFrequencies = (text: string) => {
		setSearchTextFrequencies(text);
	}

  const handleInputChangeSelectorServiceTypes = (text: string) => {
		setSearchTextServiceTypes(text);
	}

	const handleInputChangeSites = (selected: ISite[]) => {
		if(selected) {
			const changedSites = selected.map(site => ({ value: site._id, label: site.name, ...site }))
			setSelectedSites(changedSites);
		} else {
			setSelectedSites([]);
		}
	}

	const handleInputChangeUsers = (selected: IAutocompleteOption[]) => {
		if(selected) {
			setSelectedUsers(selected);
		} else {
			setSelectedUsers([]);
		}
  }

	const handleInputChangeGroups = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedGroups(selected);
		} else {
			setSelectedGroups([]);
		}
	}

  const handleInputChangeAreas = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedAreas(selected);
		} else {
			setSelectedAreas([]);
		}
	}

	const handleInputChangePlaces = (selected: IAutocompleteOption[])=> {
		if (selected) {
			setSelectedPlaces(selected);
		} else {
			setSelectedPlaces([]);
		}
	}

	const handleInputChangeEquipments = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedEquipmentModels(selected);
		} else {
			setSelectedEquipmentModels([]);
		}
	}

	const handleInputChangeCompanies = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedCompanies(selected);
		} else {
			setSelectedCompanies([]);
		}
	}

  const handleInputChangeFrequencies = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedFrequencies(selected);
		} else {
			setSelectedFrequencies([]);
		}
	}

  const handleInputChangeServiceTypes = (selected: IAutocompleteOption[]) => {
		if (selected) {
			setSelectedServiceTypes(selected);
		} else {
			setSelectedServiceTypes([]);
		}
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.scheduledServicesSetCalendarsFilters({
			equipmentModels: selectedEquipmentModels,
			areas: selectedAreas,
      companies: selectedCompanies,
      equipmentGroups: selectedGroups,
      frequencies: selectedFrequencies, 
      places: selectedPlaces,
      serviceTypes: selectedServiceTypes,
      users: selectedUsers,
		}))
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([]);
		setSelectedEquipmentModels([]);
		setSelectedGroups([]);
		setSelectedAreas([]);
		setSelectedCompanies([]);
    setSelectedFrequencies([]);
    setSelectedServiceTypes([]);
		setSelectedUsers([]);
	}

	const isAnyFilterSelected = selectedPlaces.length > 0
		|| selectedAreas.length > 0
		|| selectedCompanies.length > 0
		|| selectedEquipmentModels.length > 0
		|| selectedFrequencies.length > 0
		|| selectedServiceTypes.length > 0
		|| selectedGroups.length > 0
		|| selectedUsers.length > 0;

	return (
		<Box sx={styles.container}>
			<Box sx={styles.headerContainer}>
				<Box sx={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList sx={{ marginRight: '1rem' }} />
					{i18n.t('scheduledServicesCalendarFilterModal.filter') as string}
					{ isAnyFilterSelected && <Box sx={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('scheduledServicesCalendarFilterModal.clear') as string}</Box>}
				</Box>
				<IconButton onClick={() => props.closeModal()} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</Box>
			<Box sx={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('scheduledServicesCalendarFilterModal.site')}
						data={sitesFormated}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						id="site"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingUsersForFilters}
            label={i18n.t('scheduledServicesCalendarFilterModal.user') as string}
            data={usersFormated}
            onSelectValue={handleInputChangeUsers}
            valueSelected={selectedUsers}
            newSearchText={handleInputChangeSelectorUsers}
            id='users'
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipmentModels}
						label={i18n.t('scheduledServicesCalendarFilterModal.equipmentModel')}
						data={equipmentModelsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipmentModels}
						newSearchText={handleInputChangeSelectorEquipments}
						id="equipmentModel"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingGroups}
						label={i18n.t('scheduledServicesCalendarFilterModal.groups')}
						data={groupsFormated}
						onSelectValue={handleInputChangeGroups}
						valueSelected={selectedGroups}
						newSearchText={handleInputChangeSelectorGroups}
						id="equipmentGroup"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingServiceTypes}
						label={i18n.t('autocompleteModalFilterService.serviceTypes')}
						data={serviceTypesFormated}
						onSelectValue={handleInputChangeServiceTypes}
						valueSelected={selectedServiceTypes}
						newSearchText={handleInputChangeSelectorServiceTypes}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingFrequencies}
						label={i18n.t('autocompleteModalFilterService.frequencies')}
						data={frequenciesFormated}
						onSelectValue={handleInputChangeFrequencies}
						valueSelected={selectedFrequencies}
						newSearchText={handleInputChangeSelectorFrequencies}
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('scheduledServicesCalendarFilterModal.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						id="place"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('scheduledServicesCalendarFilterModal.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						id="area"
						isMulti
					/>
				</FormControl>
				{ role !== 'contractor' && <FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingCompanies}
						label={i18n.t('scheduledServicesCalendarFilterModal.company')}
						data={companiesFormated}
						onSelectValue={handleInputChangeCompanies}
						valueSelected={selectedCompanies}
						newSearchText={handleInputChangeSelectorCompanies}
						id="company"
						isMulti
					/>
				</FormControl>}

			</Box>
			<Box sx={styles.footerContainer}>
				<Box
					onClick={() => props.closeModal()}
					sx={styles.buttonCancel}
				>
					{i18n.t('scheduledServicesCalendarFilterModal.cancel') as string}
				</Box>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					sx={styles.button}
				>
					{i18n.t('scheduledServicesCalendarFilterModal.ok') as string}
				</Button>
			</Box>
		</Box>
	);
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
  headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: '10px',
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}

export default ScheduledServicesCalendarsFiltersModal;
